// Menu.js
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import "./Carrinho.css";
import Close from "../../assets/imgs/close.svg";
import CarrinhoContent from "./CarrinhoContent";

const Menu = ({ toggleSidebar, isOpen, setIsOpen }) => {

  const sidebarRef = useRef(null);
  const closeSidebar = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      toggleSidebar();
      
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeSidebar);
    return () => {
      document.removeEventListener("mousedown", closeSidebar);
    };
  });

  const main = process.env.REACT_APP_MAIN;

  return (
    <>
      <CSSTransition in={isOpen} timeout={500} classNames="fade" unmountOnExit>
        <div className="carrinho-container">
          <div className="sidebar" ref={sidebarRef}>
            <button
              className="menu-toggle close-menu-btn"
              onClick={toggleSidebar}
            >
              <img src={Close} alt="Close" />
            </button>

            <CarrinhoContent onCloseCarrinho={toggleSidebar} />

          </div>
          <div className="curtain"></div>
        </div>
      </CSSTransition>
    </>
  );
};

export default Menu;
